export const CUSTOMER_BASE = {
  startDate: 1679414201355, // 2023-03-21
  startUsers: 1215,
  weeklyNewUsers: 200,
};

export function computeCustomerCount(now = Date.now()) {
  const weeks = (now - CUSTOMER_BASE.startDate) / (7 * 24 * 60 * 60 * 1000);
  return Math.floor(CUSTOMER_BASE.startUsers + weeks * CUSTOMER_BASE.weeklyNewUsers);
}
